<template>
  <div>
    <button class="flex-y-center gap-2 group" @click="$emit('back')">
      <i
        class="icon-chevron-left text-lg md:text-2xl block font-thin text-dark transition group-hover:-translate-x-1"
      />
      <span
        class="font-interDisplay text-2xl md:text-[32px] leading-130 font-bold text-dark"
      >
        {{ $t("forget_password") }}
      </span>
    </button>
    <p class="text-sm md:text-base leading-130 font-normal text-gray-0/60 mt-1">
      {{ $t("send_reset_password") }}
    </p>
    <FInput
      :placeholder="$t('enter_email')"
      v-model.trim="values.email"
      :error="$v.email?.$error"
      class="mt-8 mb-4"
      prefix-class="text-2xl text-gray-450 font-semibold flex items-center mr-3 leading-130"
    >
      <template #prefix>
        <i class="icon-email" />
      </template>
    </FInput>
    <SButton
      class="w-full"
      :text="$t('send')"
      @click="submit"
      :loading="loading"
      v-bind="{ disabled }"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, unref, watch } from "vue";
import SButton from "@/components/Common/CButton.vue";
import { useCustomToast } from "@/composables/useCustomToast";
import { useI18n } from "vue-i18n";
import { useAuthStore } from "@/modules/Auth/stores";
import FInput from "@/components/Form/Input/FInput.vue";
import ApiService from "@/services/ApiService";

interface Props {
  form: any;
}
const props = defineProps<Props>();
const { $v, values } = unref(props.form);

const emit = defineEmits(["submit", "back", "on-block"]);

const { showToast } = useCustomToast();
const store = useAuthStore();
const { t } = useI18n();

const disabled = ref(true);
const loading = ref(false);

async function submit() {
  $v.value.$touch();

  if (!$v.value.email.$invalid) {
    loading.value = true;

    ApiService.post(`user/recovery/email/`, {
      email: values.email?.toLowerCase(),
    })
      .then(() => {
        showToast(t("verification_code"), "success");
        emit("submit");
      })
      .catch((err: any) => {
        if (err?.response?.status === 429) {
          emit("on-block");
          store.blockedTime = +err?.response?.headers["retry-after"];
        } else {
          showToast(
            err?.response?.data?.non_field_errors?.[0]
              ? t("user_with_email_not_exists")
              : t("some_error"),
            "error",
          );
        }
      })
      .finally(() => (loading.value = false));
  }
}

watch(
  () => $v.value.email.$invalid,
  () => {
    disabled.value = $v.value.email.$invalid;
  },
  { immediate: true },
);
</script>
